import
  React
from 'react';

import
  styled
from 'styled-components';

import {
  Colors,
  FontFamilies,
  FontSizes,
  Theme,
  MediaQueries,
} from 'common';

import {
  Arrow,
  Button,
  Text
} from 'common/components';

const Container = styled.div``;

const Header = styled.div`
  background-color: ${Theme.Card.Background};
  color: ${Theme.Text.Color};
  font-family: ${FontFamilies.Bold};
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;

  @media only screen and ${MediaQueries.Md} {
    font-size: ${FontSizes.Big};
    padding: 20px 20px 15px 20px;
  }
`;

const Row = styled.div`
  display: flex;
  position: relative;
  padding: ${props => props.padding || '10px 20px'};
  width: 100%;
  ${props => props.desktopOnly && 'display: none;'}

  @media only screen and ${MediaQueries.Md} {
    display: flex;
  }
`;

const Col = styled.div`
  color: ${Colors.White};
  ${props => props.width && `width: ${props.width};`}
  ${props => props.flex && `flex: ${props.flex};`}
  ${props => props.textAlign && `text-align: ${props.textAlign};`}
`;

const Divide = styled.div`
  background-color: ${Theme.Divider.Color};
  height: 1px;
`;

const DesktopDivide = styled.div`
  display: none;

  @media only screen and ${MediaQueries.Md} {
    display: block;
    background-color: ${Theme.Divider.Color};
    height: 1px;
  }
`;


const ArrowContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const EventMobileTicketSummary = props => {

  const totals = props.totals || {};
  const coupon = props.coupon || null;

  const selectedTickets = totals?.selectedTickets
    ? Object.values(totals?.selectedTickets)
    : [];

  const selectedMerch = totals?.selectedMerch
    ? Object.values(totals?.selectedMerch)
    : [];

  const selectedPackages = totals?.selectedPackages
    ? Object.values(totals?.selectedPackages)
    : [];

  const onCheckoutClick = () => {
    props.onCheckoutClick && props.onCheckoutClick();
  };

  // Helper function to check if a ticket has a discount
  const getTicketDiscountInfo = (ticket) => {
    if (!coupon || !coupon.items || !Array.isArray(coupon.items)) {
      return null;
    }

    const couponItem = coupon.items.find(item => item.event_price_id === ticket.id);
    if (!couponItem) {
      return null;
    }

    const originalPrice = ticket.count * ticket.price;
    const discountedPrice = ticket.totalPrice;
    const savings = originalPrice - discountedPrice;

    if (savings > 0) {
      return {
        originalPrice,
        discountedPrice,
        savings
      };
    }

    return null;
  };

  const ticketCategories = [];
  let totalSavings = 0;

  for (const ticket of selectedTickets) {

    if (!ticket.count) {
      continue;
    }

    const discountInfo = getTicketDiscountInfo(ticket);
    if (discountInfo) {
      totalSavings += discountInfo.savings;
    }

    ticketCategories.push(
      <div key={ticket.id}>
        <Row>
          <Col flex={'1'}>
            <Text padding={'0 10px 0 0'} fontSize={FontSizes.Small}>{ticket.title}</Text>
          </Col>
          <Col width={'45px'}>
            <Text fontSize={FontSizes.Small} padding={'0 6px'}>X{ticket.count}</Text>
          </Col>
          <Col width={'120px'} textAlign={'right'}>
            {discountInfo ? (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '2px' }}>
                <Text fontSize={FontSizes.Small} style={{ textDecoration: 'line-through', opacity: 0.6 }}>
                  R{discountInfo.originalPrice.toFixed(2)}
                </Text>
                <Text fontSize={FontSizes.Small} style={{ color: '#28a745', fontWeight: 'bold' }}>
                  R{discountInfo.discountedPrice.toFixed(2)}
                </Text>
              </div>
            ) : (
              <Text fontSize={FontSizes.Small}>R{ticket.totalPrice.toFixed(2)}</Text>
            )}
          </Col>
        </Row>
      </div>
    );
  }

  for (const merch of selectedMerch) {

    if (!merch.count) {
      continue;
    }

    const key = !merch.option_id ? `product-merch-${merch.product_id}` : `variant-merch-${merch.option_id}`;
    const productText = merch.is_simple_product ? merch.product_name : merch.product_name + ' - ' + merch.option_value;

    ticketCategories.push(
      <Row
        key={key}>

        <Col flex={'1'}>
        
          <Text padding={'0 10px 0 0'} fontSize={FontSizes.Small}>{productText}</Text>

        </Col>

        <Col width={'45px'}>
          
          <Text fontSize={FontSizes.Small} padding={'0 6px'}>X{merch.count}</Text>

        </Col>

        <Col width={'120px'} textAlign={'right'}>
          
          <Text fontSize={FontSizes.Small}>R{merch.totalPrice.toFixed(2)}</Text>
          
        </Col>

      </Row>
    );
  }

  for (const pkg of selectedPackages) {
  
    if (!pkg.count) {
      continue;
    }

    ticketCategories.push(
      <Row key={pkg.packageId}>

        <Col flex={'1'}>
          <Text padding={'0 10px 0 0'} fontSize={FontSizes.Small}>{pkg.name}</Text>
        </Col>
        
        <Col width={'45px'}>  
          <Text fontSize={FontSizes.Small} padding={'0 6px'}>X{pkg.count}</Text>
        </Col>

        <Col width={'120px'} textAlign={'right'}>
          <Text fontSize={FontSizes.Small}>R{pkg.totalPrice?.toFixed(2)}</Text>
        </Col>

      </Row>
    );
  }

  return (

    <Container>

      <Header>
        
        <span>Your Order</span>
        
        { props.onArrowClick &&

          <ArrowContainer
            onClick={props.onArrowClick}>

            <Arrow
              active={true}
              size={'10px'}
              direction={'down'}
            />

          </ArrowContainer>
        }

      </Header>

      <Divide/>

      { ticketCategories.length
        
        ? <div style={{ overflow: 'auto' }}>{ticketCategories}</div>
        
        : <Row>
            <Text fontSize={FontSizes.Small}>No items selected</Text>
          </Row>
      }

      <Divide/>

      {totalSavings > 0 && (
        <>
          <Row>
            <Col flex={'1'}>
              <Text fontSize={FontSizes.Small}>Subtotal:</Text>
            </Col>
            <Col width={'45px'}>
              <Text fontSize={FontSizes.Small} padding={'0 6px'}>X{totals.tickets}</Text>
            </Col>
            <Col width={'120px'} textAlign={'right'}>
              <Text fontSize={FontSizes.Small} style={{ textDecoration: 'line-through', opacity: 0.6 }}>
                R{(totals.price + totalSavings).toFixed(2)}
              </Text>
            </Col>
          </Row>
          <Row padding={'0 20px'}>
            <Col flex={'1'}>
              <Text fontSize={FontSizes.Small} style={{ color: '#28a745' }}>
                Discount:
              </Text>
            </Col>
            <Col width={'45px'}>
              <Text fontSize={FontSizes.Small} padding={'0 6px'}></Text>
            </Col>
            <Col width={'120px'} textAlign={'right'}>
              <Text fontSize={FontSizes.Small} style={{ color: '#28a745' }}>
                -R{totalSavings.toFixed(2)}
              </Text>
            </Col>
          </Row>
        </>
      )}

      <Row>

        <Col flex={'1'}>

          <Text fontFamily={FontFamilies.Bold} fontSize={FontSizes.Small}>Total:</Text>

        </Col>

        <Col width={'45px'}>

          <Text fontFamily={FontFamilies.Bold} fontSize={FontSizes.Small} padding={'0 6px'}>X{totals.tickets}</Text>

        </Col>

        <Col width={'120px'} textAlign={'right'}>

          <Text fontFamily={FontFamilies.Bold} fontSize={FontSizes.Small}>R{totals.price.toFixed(2)}</Text>
          
        </Col>

      </Row>

      <DesktopDivide/>

      { props.children &&
      
        <Row padding={'20px'}>
          {props.children}
        </Row>
      }

      { !props.hideCheckoutButton &&
      
        <Row padding={'20px'} desktopOnly>

          <Button
            onClick={onCheckoutClick}
            disabled={props.checkoutDisabled}
            width={'100%'}>
              Checkout
          </Button>

        </Row>
      }

    </Container>
  );
};